export enum VehicleType {
  New = 'New',
  PreOwned = 'Pre-owned',
  CertifiedPreOwned = 'Certified Pre-owned',
  Sample = 'Sample',
}
